import { useMediaQuery } from '@/hooks/use-media-query';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import { useTranslation } from 'react-i18next';

type TRefundByCheckDialog = {
  isOpen: boolean;
  toggleIsOpen: () => void;
  onClickProp?: () => void;
  navigateToCheck: () => void;
};

const RefundByCheckDialog = ({
  isOpen,
  toggleIsOpen,
  onClickProp,
  navigateToCheck,
}: TRefundByCheckDialog) => {
  const isDesktop = useMediaQuery('(min-width: 768px)');
  const { t } = useTranslation();

  const onClick = () => {
    if (onClickProp) {
      onClickProp();
      return;
    }

    navigateToCheck();
  };

  if (isDesktop) {
    return (
      <Dialog open={isOpen} onOpenChange={toggleIsOpen}>
        <DialogContent className='p-16 lg:min-w-[600px]'>
          <DialogHeader>
            <DialogTitle className='mb-6 text-2xl font-bold'>
              {t('Check By Mail')}
            </DialogTitle>
            <DialogDescription className='text-muted-foreground'>
              {t(
                'Checks can take up to 20 business days, and run the risk of getting lost in the mail. Instead, you can opt for',
              )}{' '}
              <span className='font-bold text-primary-700'>
                {t('direct deposit')}
              </span>{' '}
              {t('that will return your funds much quicker.')}
              <br />
              <br />
              {t('Do you want to continue?')}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className='flex w-full items-center justify-center gap-6'>
            <div className='flex min-h-[80px] w-full flex-col justify-between gap-2'>
              <p className='text-sm text-muted-foreground'>
                {t('Direct Deposit 3-5 business days')}
              </p>
              <Button
                variant='success'
                className='w-full'
                onClick={toggleIsOpen}
              >
                {t('I want the Payment Faster')}
              </Button>
            </div>
            <div className='flex min-h-[80px] w-full flex-col justify-between gap-2'>
              <p className='text-sm text-muted-foreground'>
                {t('Check Sent within 20 business days')}
              </p>
              <Button variant='outline' className='w-full' onClick={onClick}>
                {t('Continue')}
              </Button>
            </div>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={isOpen} onClose={toggleIsOpen}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle className='mb-6 text-2xl font-bold'>
            {t('Check By Mail')}
          </DrawerTitle>
          <DrawerDescription className='text-left text-muted-foreground'>
            {t(
              'Checks can take up to 20 business days, and run the risk of getting lost in the mail. Instead, you can opt for',
            )}{' '}
            <span className='font-bold text-primary-700'>
              {t('digital payment')}
            </span>{' '}
            {t('option this is faster and more reliable.')}
            <br />
            <br />
            {t('Do you want to continue?')}
          </DrawerDescription>
        </DrawerHeader>
        <DrawerFooter className='flex w-full items-center justify-center gap-6'>
          <div className='flex w-full flex-col gap-2'>
            <p className='text-sm text-muted-foreground'>
              {t('Digital Option 3-5 business days')}
            </p>
            <Button variant='success' className='w-full' onClick={toggleIsOpen}>
              {t('I want the Payment Faster')}
            </Button>
          </div>
          <div className='flex w-full flex-col gap-2'>
            <p className='text-sm text-muted-foreground'>
              {t('Please send it in a paper check')}
            </p>
            <p className='text-sm text-muted-foreground'>
              {t('It can take up to 15 business days')}
            </p>
            <Button variant='outline' className='w-full' onClick={onClick}>
              {t('Continue')}
            </Button>
          </div>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default RefundByCheckDialog;
